const SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const LONG = ["January", "February", "March", "April", "May", "June", "July", "August",
  "September", "October", "November", "December"];

/** "2026-08" -> "Aug 2026"; "August 2026" -> "Aug 2026"; anything else passes through. */
export const fmtPeriod = (value) => {
  if (!value) return "";
  const iso = /^(\d{4})-(\d{2})$/.exec(String(value));
  if (iso) return `${SHORT[Number(iso[2]) - 1]} ${iso[1]}`;
  const named = /^([A-Za-z]+)\s+(\d{4})$/.exec(String(value));
  if (named) {
    const i = LONG.findIndex((m) => m.toLowerCase() === named[1].toLowerCase());
    if (i !== -1) return `${SHORT[i]} ${named[2]}`;
  }
  return String(value);
};

export const NOT_ASSESSED = "Not yet assessed";
